import { render, staticRenderFns } from "./MailOrdine.vue?vue&type=template&id=670b0713&"
import script from "./MailOrdine.vue?vue&type=script&lang=js&"
export * from "./MailOrdine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports